import React from 'react';

interface IFavoritosContext {
    enlaceClick: boolean;
    setEnlaceClick: any;
    favoritosSWRKey: string;
    favoritosID: string;
    actualizarIdClick: any;
};

export const FavoritosContext = React.createContext<IFavoritosContext>({enlaceClick: false, setEnlaceClick: () => {}, favoritosSWRKey:"favoritos", favoritosID:"fav_1",actualizarIdClick: null});
